import { render, staticRenderFns } from "./Merchant.vue?vue&type=template&id=af0f9e10&scoped=true&"
import script from "./Merchant.vue?vue&type=script&lang=js&"
export * from "./Merchant.vue?vue&type=script&lang=js&"
import style0 from "./Merchant.vue?vue&type=style&index=0&id=af0f9e10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0f9e10",
  null
  
)

export default component.exports